var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentName,_vm._b({tag:"component",staticClass:"re-profile-giftcards",attrs:{"tabs":_vm.giftCardsTabs()},on:{"recoverByEmail":_vm.recoverByEmail,"recoverByNumber":_vm.recoverByNumber,"addCard":_vm.addGiftCard}},'component',_vm.componentAttrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }